import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('navigation');
  return (
    <footer style={{ backgroundColor: '#333', color: '#fff', textAlign: 'center', padding: '10px' }}>
      <p>{t('footer.copyright')} {t('footer.allRightsReserved')}</p>
    </footer>
  );
};

export default Footer;
